import { render, staticRenderFns } from "./loan-audit.vue?vue&type=template&id=90f8010c&scoped=true&"
import script from "./loan-audit.vue?vue&type=script&lang=js&"
export * from "./loan-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f8010c",
  null
  
)

export default component.exports